import { ViewLikesContextActionType } from '../types'
import { useViewLikesDispatch } from '../ViewLikesContext'

export const setSearchTerm = (text: string) => {
    const dispatch = useViewLikesDispatch()
    dispatch({
        type: ViewLikesContextActionType.SET_SEARCH_TERM,
        payload: text
    })
}
